import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wo-entry-explanations"
};
const _hoisted_2 = {
  class: "entry-content"
};
import { computed, onMounted, ref } from 'vue';
import { request } from '@/manager/net_manager';
import store from "@/store"; // refs

export default {
  __name: 'WOEntryExplanations',

  setup(__props) {
    const dataArray = ref([]);
    const activeRouter = ref([]);
    const activeContent = ref(null);
    const activeSubEntries = ref([]); // computed

    const worldOutlook = computed(() => store.state.world_outlook); // functions

    const getData = () => {
      let parameters = {};

      if (worldOutlook.value !== null) {
        parameters['world_outlook_id'] = worldOutlook.value.id;
        request('world_outlook/get_entry_explanations_list/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            dataArray.value = response.data;
          }
        });
      }
    };

    const getEntryData = entryId => {
      request('world_outlook/get_entry_explanations/', {
        'entry_id': entryId
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          activeContent.value = response.data['content'];
          activeSubEntries.value = response.data['sub_entries']; // this.activeEntries[this.activeEntries.length - 1]
        }
      });
    };

    const clearEntry = () => {
      activeRouter.value = [];
      activeContent.value = null;
      activeSubEntries.value = [];
    };

    const onSelectEntry = entry => {
      getEntryData(entry.id);
      activeRouter.value.push(entry);
    };

    const entrySelected = (entry, index) => {
      if (index === activeRouter.value.length) return;

      if (index === 0) {
        clearEntry();
        return;
      }

      activeRouter.value = activeRouter.value.slice(0, index);
      getEntryData(entry.id);
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_check_tag = _resolveComponent("el-check-tag");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_collapse_item = _resolveComponent("el-collapse-item");

      const _component_el_collapse = _resolveComponent("el-collapse");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_collapse, {
        accordion: "",
        onChange: clearEntry,
        ref: "ccc"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key, index) => {
          return _openBlock(), _createBlock(_component_el_collapse_item, {
            key: index,
            name: index,
            ref_for: true,
            ref: `red_${index}`
          }, {
            title: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(item['title']), 1)]),
            default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("div", {
              class: "divider"
            }, null, -1)), _createVNode(_component_el_col, null, {
              default: _withCtx(() => [activeRouter.value.length !== 0 ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0
              }, {
                default: _withCtx(() => [_createVNode(_component_el_breadcrumb, {
                  separator: "/"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([item, ...activeRouter.value], (entry, index) => {
                    return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
                      key: index,
                      onClick: $event => entrySelected(entry, index)
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(entry.title), 1)]),
                      _: 2
                    }, 1032, ["onClick"]);
                  }), 128))]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createElementVNode("text", _hoisted_2, "    " + _toDisplayString(activeContent.value ?? item['content']), 1)]),
                _: 2
              }, 1024), activeRouter.value.length === 0 && item['sub_entries'].length !== 0 || activeRouter.value.length !== 0 && activeSubEntries.value.length !== 0 ? (_openBlock(), _createBlock(_component_el_row, {
                key: 1,
                class: "subEntries"
              }, {
                default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("text", {
                  class: "subEntriesTips"
                }, "可展开词条", -1)), _cache[1] || (_cache[1] = _createElementVNode("text", {
                  class: "separator"
                }, " /", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeRouter.value.length === 0 ? item['sub_entries'] : activeSubEntries.value, (subItem, subIndex) => {
                  return _openBlock(), _createBlock(_component_el_check_tag, {
                    key: subIndex,
                    onChange: $event => onSelectEntry(subItem)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(subItem['title']), 1)]),
                    _: 2
                  }, 1032, ["onChange"]);
                }), 128))]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 512)]);
    };
  }

};